import { ObjectDirective } from 'vue';
import { usePermission } from '@/hooks/web/usePermission';

function checkString(value: string, el: HTMLButtonElement): boolean {
  const { hasPermission } = usePermission();
  if (!hasPermission([value])) {
    el.remove();
    return true;
  }
  return false;
}

export const permission: ObjectDirective = {
  mounted(el: HTMLButtonElement, binding) {
    if (binding.value == undefined) return;
    const bindingValueType = typeof binding.value;
    const { hasPermission } = usePermission();
    // 1. 如果传入的是字符串或数组
    if (bindingValueType === 'string' || bindingValueType === 'number') {
      const bindingValue: string = binding.value.toString();
      checkString(bindingValue, el);
    }
    // 2. 如果传入的是数组
    else if (bindingValueType === 'object' && Array.isArray(binding.value)) {
      let bindValue = binding.value;
      bindValue = bindValue
        .filter((item) => {
          return typeof item === 'string' || typeof item === 'number';
        })
        .map((item) => item.toString());
      if (!hasPermission(bindValue)) {
        el.remove();
      }
    } else if (bindingValueType === 'object') {
      const { action, effect } = binding.value;
      if (!hasPermission(action)) {
        if (effect == 'disabled') {
          el.disabled = true;
          el.style['disabled'] = 'disabled';
          el.classList.add('n-button--disabled');
        } else {
          el.remove();
        }
      }
    }
  },
};
